import RelatedPostsSlider from "../RelatedPostsSlider";

import SummaryModule from "./modules/SummaryModule";
import PostAndCommentsModule from "./modules/PostAndCommentsModule";

function ClusterData({ clusterName, clusterData }) {
  console.log(
    "cluster name and cluster data: ",
    clusterData,
    "summary: ",
    clusterData.insightSummary,
  );
  return (
    <div className="h-auto w-full">
      <div className="flex h-auto flex-col justify-start">
        <h1 className="text-left text-2xl font-bold">
          Insight Cluster: {clusterName}{" "}
          <p className="inline-block text-gray-400">
            {clusterData?.totalSubmittedPosts} submitted post(s)
          </p>
        </h1>
        <p className="text-left text-xl text-gray-400">
          {" "}
          Highlight Posts & Comments
        </p>
      </div>
      <div
        id="cluster-container"
        className="grid h-auto min-h-[500px] grid-cols-5 space-x-6"
      >
        {clusterData?.insightSummary && (
          <>
            <SummaryModule
              id="cluster-ai-summary"
              className="col-span-2 rounded-md p-6 text-left shadow-md"
              title="INSIGHT SUMMARY"
              subtitle={clusterData.insightSummary ?? ""}
              content={clusterData?.exampleSentences ?? []}
              col={true}
              colSpan={2}
            />
            <PostAndCommentsModule clusterData={clusterData} />
          </>
        )}

        {/* video and comments conatiner */}
      </div>
      {clusterData && (
        <RelatedPostsSlider data={clusterData.insightRelatedPosts} />
      )}
    </div>
  );
}

export default ClusterData;
